// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Header_navLink_3PMn9","add-nav-padding-left":"Header_add-nav-padding-left_27uF8","spinAround":"Header_spinAround_13Oqa"};